import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as Sentry from '@sentry/react';
import { AppRouter } from './routes';
import { UpdateToast } from './components/pwa/UpdateToast';
import { OfflineBanner } from './components/pwa/OfflineBanner';

function ErrorFallback() {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 p-8">
      <div className="text-center">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">Algo sali\u00f3 mal</h1>
        <p className="mb-6 text-gray-600">
          Ocurri\u00f3 un error inesperado. Nuestro equipo ha sido notificado.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-blue-600 px-6 py-2 text-white hover:bg-blue-700"
        >
          Recargar p\u00e1gina
        </button>
      </div>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
});

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
        <OfflineBanner />
        <UpdateToast />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
